<nz-modal *ngIf="visible" [(nzVisible)]="visible" [nzTitle]="title" (nzOnCancel)="close()">
  <ng-container *nzModalContent>
    <nz-tree
      #tree
      [nzData]="nodes"
      nzCheckable
      nzMultiple
      [nzCheckedKeys]="defaultCheckedKeys"
      (nzCheckBoxChange)="nzEvent($event)"
    ></nz-tree>
  </ng-container>
  <div *nzModalFooter>
    <div style="margin-top: -5px">
      <button nz-button nzType="default" (click)="close()">取消</button>
      <button nz-button nzType="primary" [nzLoading]="loading" (click)="submit()">确定</button>
    </div>
  </div>
</nz-modal>
